module.exports = __webpack_public_path__ + "img/transgender.f49ed55f.svg";